import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [
    { path: '', redirectTo: '/app/main/dashboard', pathMatch: 'full' },
    {
        path: 'mass-casualty',
        loadChildren: () =>
            import('public/mass-casualty/mass-casualty-public.module').then(
                (m) => m.MassCasualtyPublicModule
            ),
    },
    {
        path: 'public',
        loadChildren: () => import('public/public.module').then((m) => m.PublicModule),
    },
    {
        path: 'account',
        loadChildren: () => import('account/account.module').then((m) => m.AccountModule), //Lazy load account module
        data: { preload: true },
    },
    {
        path: 'could-not-connect-server',
        loadChildren: () => import('connection-failed/connection-failed.module').then((m) => m.ConnectionFailedModule),
    },
    {
        path: 'install',
        loadChildren: () => import('install/install.module').then((m) => m.InstallModule),
    },
    { path: '**', redirectTo: '/app/main/dashboard' },
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule],
})
export class RootRoutingModule {}
